<div class="filter">
  <nz-select
    [nzMaxTagCount]="1"
    nzShowSearch
    nzAllowClear
    [nzShowArrow]="true"
    [ngModel]="timelineModalFilterService.staffAvailability$ | async"
    (ngModelChange)="availableStaffChanged($event)"
  >
    <nz-option
      [nzValue]="AssignmentAvailabilityStatus.Available"
      [nzLabel]="
        'page.shift_timeline.find_staff_modal.filter.available' | translate
      "
    ></nz-option>
    <nz-option
      [nzValue]="AssignmentAvailabilityStatus.NotAvailable"
      [nzLabel]="
        'page.shift_timeline.find_staff_modal.filter.not_available' | translate
      "
    ></nz-option>
  </nz-select>
</div>
